// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2ULMR","inner":"Footer_inner__1KFWG"};